import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import NotificationGroup from "./notification-group";
import { NotificationGroup as NotificationGroupType } from "./types";

const FeedContainer = css({
    padding: token("space.200")
});

interface GroupedNotifications {
    today: NotificationGroupType[];
    yesterday: NotificationGroupType[];
    thisWeek: NotificationGroupType[];
    thisMonth: NotificationGroupType[];
    older: NotificationGroupType[];
}

const NotificationFeed = ({
    groupedNotifications
}: {
    groupedNotifications: GroupedNotifications;
}) => {
    const { today, yesterday, thisWeek, thisMonth, older } =
        groupedNotifications;

    return (
        <div css={FeedContainer}>
            {today.length > 0 && (
                <NotificationGroup title="Today" notificationGroups={today} />
            )}
            {yesterday.length > 0 && (
                <NotificationGroup
                    title="Yesterday"
                    notificationGroups={yesterday}
                />
            )}
            {thisWeek.length > 0 && (
                <NotificationGroup
                    title="This Week"
                    notificationGroups={thisWeek}
                />
            )}
            {thisMonth.length > 0 && (
                <NotificationGroup
                    title="This Month"
                    notificationGroups={thisMonth}
                />
            )}
            {older.length > 0 && (
                <NotificationGroup title="Older" notificationGroups={older} />
            )}
        </div>
    );
};

export default NotificationFeed;
